const LinkedIn = () => (
    <svg
        width='20'
        height='21'
        viewBox='0 0 20 21'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        id='linked-in'
    >
        <path
            d='M5 3.5C5 4.6 4.3 5.5 3 5.5C1.8 5.5 1 4.6 1 3.6C1 2.5 1.8 1.5 3 1.5C4.2 1.5 5 2.4 5 3.5ZM1 19.5H5V6.5H1V19.5ZM14.6 6.7C12.5 6.7 11.3 7.9 10.8 8.7H10.7L10.5 7H6.9C6.9 8.1 7 9.4 7 10.9V19.5H11V12.4C11 12 11 11.7 11.1 11.4C11.4 10.7 11.9 9.8 13 9.8C14.4 9.8 15 11 15 12.6V19.5H19V12.1C19 8.4 17.1 6.7 14.6 6.7Z'
            fill='#23B3E5'
        />
    </svg>
);

export default LinkedIn;
